import { render, staticRenderFns } from "./ModalRechargeByPix.vue?vue&type=template&id=7d9c5ba8&"
import script from "./ModalRechargeByPix.vue?vue&type=script&lang=js&"
export * from "./ModalRechargeByPix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
